import { render, staticRenderFns } from "./info-dialog-box.vue?vue&type=template&id=0795a4f4&scoped=true&"
import script from "./info-dialog-box.vue?vue&type=script&lang=js&"
export * from "./info-dialog-box.vue?vue&type=script&lang=js&"
import style0 from "./info-dialog-box.vue?vue&type=style&index=0&id=0795a4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795a4f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon})
